import { render, staticRenderFns } from "./AdminSalesView.vue?vue&type=template&id=09523a3c&scoped=true"
import script from "./AdminSalesView.vue?vue&type=script&lang=js"
export * from "./AdminSalesView.vue?vue&type=script&lang=js"
import style0 from "./AdminSalesView.vue?vue&type=style&index=0&id=09523a3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09523a3c",
  null
  
)

export default component.exports